import { computed, watch } from "vue";

/** Reports uncapped match status from the same pipeline that supplies rendered rows. */
export function useRenderedResults(props, emit, matchedItems, hasMatches) {
  watch([hasMatches, () => props.mapResults], reportMatches, { immediate: true });

  function reportMatches([hasMatch]) {
    if (props.mapResults) {
      emit("update-matches", hasMatch);
    }
  }

  const renderedItems = computed(() => props.mapResults?.(matchedItems.value) ?? matchedItems.value);

  return { renderedItems };
}
